import { createTheme } from '@mui/material/styles';
import { COLORS } from 'utils/GlobalVariables';

export const generalTheme = createTheme({
  palette: {
    primary: { main: COLORS.yellow, contrastText: COLORS.white },
    secondary: { main: COLORS.green, contrastText: COLORS.white },
  },
  typography: {
    fontFamilyLight: 'Rubik-Light',
    fontFamily: 'Rubik',
    fontFamilyMedium: 'Rubik-Medium',
    fontFamilySemiBold: 'Rubik-SemiBold',
    fontFamilyBold: 'Rubik-Bold',
    fontFamilyExtraBold: 'Rubik-ExtraBold',
    fontFamilyBlack: 'Rubik-Black',

    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
});
